import { useState, useEffect } from "react";
import { Box, CircularProgress, Tooltip, Typography } from "@mui/material";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import { tokens } from "../../theme";
import Header from "../../components/Header";
import { useTheme } from "@mui/material";
import { useNavigate, Outlet, createSearchParams } from "react-router-dom";
import { Button } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import HttpsIcon from "@mui/icons-material/Https";
import axios from "axios";
import swal from "sweetalert";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
const Contacts = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const navigate = useNavigate();
  const [auToFetchData, setAuToFetchData] = useState(false);
  const [loadingScreen, setLoadingScreen] = useState(false);

  const handleEdit = (cellValues) => {
    const app_id = customerConfiguredApps[cellValues.id - 1].site;

    switch (app_id) {
      case "Google drive":
        navigate("/token-gating/google-drive");
        break;
      case "Circle":
        navigate("/token-gating/circle");
        break;
      case "Skool":
        navigate("/token-gating/skool");
        break;
      case "Discord":
        navigate("/token-gating/discord");
        break;
      case "Calendly":
        navigate("/configured-apps/calendly-edit", {
          state: customerConfiguredApps[cellValues.id - 1].calendlyData,
        });
        break;
      case "Discourse":
        navigate("/configured-apps/discourse-edit",{
          state : customerConfiguredApps[cellValues.id - 1].discourseData
        })
        break
      case "Zoom":
        navigate("/configured-apps/zoom-edit", {
              state: customerConfiguredApps[cellValues.id - 1].zoomData,
        });
        break;
      default:
        navigate("/configured-apps/configure", {
          state: customerConfiguredApps[cellValues.id - 1],
        });
    }
  };

  const [isCopy, setIsCopy] = useState(false);
  function saveToClipboard(url) {
    navigator.clipboard.writeText(url);
    setIsCopy(true);
  }
  function handleHover() {
    setIsCopy(false);
  }

  async function generateSsl(cellValues) {
    try {
      setLoadingScreen(true);
      await axios
        .put(
          `${process.env.REACT_APP_BASE_URL}/api/generate-ssl`,
          {
            domain: customerConfiguredApps[cellValues.id - 1].domainName,
          },
          {
            headers: {
              "content-type": "application/json",
              token: localStorage.getItem("token"),
            },
          }
        )
        .then((response) => {
          setLoadingScreen(false);

          if (response.data.status) {
            if (response.data.isSslCertsGenerated) {
              swal({
                title: "SSL certificates is successfully generated!",
                icon: "success",
              }).then(() => setAuToFetchData(true));
            } else {
              swal({
                title: "Error in generating SSL",
                icon: "error",
              });
            }
          } else {
            swal({
              title: response.data.message,
              icon: "warning",
            });
          }
        });
    } catch (error) {
      setLoadingScreen(false);
      swal({
        title: "Something went wrong!",
        icon: "error",
      });
    }
  }

  const handleProxyDelete = (cellValues) => {
    swal({
      title: "Are you sure?",
      text: "Once deleted, Nft Token Gating will be disabled for this site !",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        setLoadingScreen(true);
        if (customerConfiguredApps[cellValues.id - 1].site === "Google drive") {
          axios
            .delete(
              `${process.env.REACT_APP_BASE_URL}/google-drive-user-info?appId=Google drive`,
              {
                headers: {
                  "content-type": "application/json",
                  token: localStorage.getItem("token"),
                },
              }
            )
            .then((res) => {
              setLoadingScreen(false);
              swal({
                text: res.data.title,
                icon: "success",
                //type: "success"
              }).then(() => setAuToFetchData(true));
            })
            .catch((err) => {
              setLoadingScreen(false);
              swal({
                text: err.response.data.errorMessage,
                icon: "error",
                // type: "error"
              });
            });
        } else if (
          customerConfiguredApps[cellValues.id - 1].site === "Circle"
        ) {
          axios
            .delete(`${process.env.REACT_APP_BASE_URL}/circle-user-info`, {
              headers: {
                "content-type": "application/json",
                token: localStorage.getItem("token"),
              },
            })
            .then((res) => {
              setLoadingScreen(false);

              swal({
                text: res.data.title,
                icon: "success",
                //type: "success"
              }).then(() => setAuToFetchData(true));
            })
            .catch((err) => {
              setLoadingScreen(false);

              swal({
                text: err.response.data.errorMessage,
                icon: "error",
                // type: "error"
              });
            });
        } else if (
          customerConfiguredApps[cellValues.id - 1].site === "Discord"
        ) {
          axios
            .delete(`${process.env.REACT_APP_BASE_URL}/discord-user-info`, {
              headers: {
                "content-type": "application/json",
                token: localStorage.getItem("token"),
              },
            })
            .then((res) => {
              setLoadingScreen(false);

              swal({
                text: res.data.title,
                icon: "success",
                //type: "success"
              }).then(() => setAuToFetchData(true));
            })
            .catch((err) => {
              setLoadingScreen(false);

              swal({
                text: err.response.data.errorMessage,
                icon: "error",
                // type: "error"
              });
            });
        } else if (customerConfiguredApps[cellValues.id - 1].site === "Skool") {
          axios
            .delete(`${process.env.REACT_APP_BASE_URL}/skool-user-info`, {
              headers: {
                "content-type": "application/json",
                token: localStorage.getItem("token"),
              },
            })
            .then((res) => {
              setLoadingScreen(false);

              swal({
                text: res.data.title,
                icon: "success",
                //type: "success"
              }).then(() => setAuToFetchData(true));
            })
            .catch((err) => {
              setLoadingScreen(false);

              swal({
                text: err.response.data.errorMessage,
                icon: "error",
                // type: "error"
              });
            });
        } else if (
          customerConfiguredApps[cellValues.id - 1].site === "Calendly"
        ) {
          const proxyId = customerConfiguredApps[cellValues.id - 1]._id;
          const domainName =
            customerConfiguredApps[cellValues.id - 1].domainName;
          axios
            .post(
              `${process.env.REACT_APP_BASE_URL}/calendly-nft-token-gating-data-delete`,
              {
                proxyId: proxyId,
                domainName: domainName,
              },
              {
                headers: {
                  "content-type": "application/json",
                  token: localStorage.getItem("token"),
                },
              }
            )
            .then((res) => {
              setLoadingScreen(false);
              swal({
                text: res.data.title,
                icon: "success",
              }).then(() => setAuToFetchData(true));
            })
            .catch((err) => {
              setLoadingScreen(false);
              swal({
                text: err.response.data.errorMessage,
                icon: "error",
              });
            });
        }else if( customerConfiguredApps[cellValues.id - 1].site === "Discourse"){
          const proxyId = customerConfiguredApps[cellValues.id - 1]._id;
          const domainName =  customerConfiguredApps[cellValues.id - 1].domainName;
          axios
            .post(`${process.env.REACT_APP_BASE_URL}/discourse-nft-token-gating-data-delete`,{
              proxyId: proxyId,
              domainName: domainName,
            }, {
              headers: {
                "content-type": "application/json",
                token: localStorage.getItem("token"),
              },
            })
            .then((res) => {
              swal({
                text: res.data.title,
                icon: "success",
                //type: "success"
              });
              setAuToFetchData(true);
            })
            .catch((err) => {
              swal({
                text: err.response.data.errorMessage,
                icon: "error",
                // type: "error"
              });
            });
          }  else if (
            customerConfiguredApps[cellValues.id - 1].site === "Zoom"
          ) {
            const proxyId = customerConfiguredApps[cellValues.id - 1]._id;
            const domainName =  customerConfiguredApps[cellValues.id - 1].domainName;
            axios
              .post(`${process.env.REACT_APP_BASE_URL}/zoom-nft-token-gating-data-delete`,{
                proxyId: proxyId,
                domainName: domainName,
              }, {
                headers: {
                  "content-type": "application/json",
                  token: localStorage.getItem("token"),
                },
              })
              .then((res) => {
                swal({
                  text: res.data.title,
                  icon: "success",
                  //type: "success"
                });
                setAuToFetchData(true);
              })
              .catch((err) => {
                swal({
                  text: err.response.data.errorMessage,
                  icon: "error",
                  // type: "error"
                });
              });
          } else {
          const proxyId = customerConfiguredApps[cellValues.id - 1]._id;
          const domainName =
            customerConfiguredApps[cellValues.id - 1].domainName;
          const site = customerConfiguredApps[cellValues.id - 1].site;
          axios
            .post(
              `${process.env.REACT_APP_BASE_URL}/nft-handle-proxy-delete`,
              {
                proxyId: proxyId,
                domainName: domainName,
                siteName: site,
              },
              {
                headers: {
                  "content-type": "application/json",
                  token: localStorage.getItem("token"),
                },
              }
            )
            .then((res) => {
              setLoadingScreen(false);
              swal({
                text: res.data.title,
                icon: "success",
                //type: "success"
              }).then(() => setAuToFetchData(true));
            })
            .catch((err) => {
              setLoadingScreen(false);
              swal({
                text: err.response.data.errorMessage,
                icon: "error",
                // type: "error"
              });
            });
        }
      }
    });
  };

  const [customerConfiguredApps, setCustomerConfiguredApps] = useState([]);
  useEffect(() => {
    setLoadingScreen(true);
    axios
      .get(`${process.env.REACT_APP_BASE_URL}/nft-token-gating-dashboard`, {
        headers: {
          "content-type": "application/json",
          token: localStorage.getItem("token"),
        },
      })
      .then((res) => {
        setLoadingScreen(false);

        let filtereddata = res.data.customerConfiguredApp;
        let count = 0;
        filtereddata = filtereddata.map((obj) => {
          count++;
          return { ...obj, id: count };
        });
        setCustomerConfiguredApps(filtereddata);
        setAuToFetchData(false);
      })
      .catch((err) => {
        setLoadingScreen(false);
        if (err.response.data.errorMessage == "User unauthorized!") {
          swal({
            text: err.response.data.errorMessage,
            icon: "error",
            // type: "error",
          });

          localStorage.removeItem("token");
          setTimeout(() => window.location.reload(), 2000);
        }
        swal({
          text: err.response.data.errorMessage,
          icon: "error",
          // type: "error",
        });
      });
  }, [auToFetchData]);

  const columns = [
    {
      field: "id",
      headerName: "ID",
      width: 80,
      align: "center",
      headerAlign: "center",
    },

    {
      field: "site",
      headerName: "Application Name",
      width: 200,
      cellClassName: "name-column--cell",
      align: "center",
      headerAlign: "center",
    },
    {
      field: "domainName",
      headerName: "Domain Name",
      width: 200,
      cellClassName: "name-column--cell",
      align: "center",
      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <div style={{ display: "flex", flexDirection: "row" }}>
            <div style={{ maxWidth: "150px" }}>
              <Typography sx={{ fontFamily: "Poppins" }} noWrap>
                {customerConfiguredApps[cellValues.id - 1].domainName}
              </Typography>
            </div>
            <div>
              {!["Circle", "Google drive", "Discord", "Skool"].includes(
                customerConfiguredApps[cellValues.id - 1].site
              ) && (
                <Tooltip
                  sx={{ marginLeft: "5px" }}
                  title={isCopy ? "Copied" : "Copy link"}
                >
                  <ContentCopyIcon
                    onMouseLeave={handleHover}
                    onClick={() =>{
                      const domainName =
                        customerConfiguredApps[cellValues.id - 1].domainName;
                      const linkUrl = domainName.startsWith("https://")
                        ? domainName
                        : `https://${domainName}`;
                      saveToClipboard(linkUrl);
                    }}
                      
                  />
                </Tooltip>
              )}
            </div>
          </div>
        );
      },
    },
    {
      field: "domainStatus",
      headerName: "Domain status",
      width: 250,
      cellClassName: "name-column--cell",
      align: "center",
      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <div>
            {[
              "Circle",
              "Google drive",
              "Discord",
              "Skool",
              "Calendly",
              "Discourse",
              "Zoom"
            ].includes(customerConfiguredApps[cellValues.id - 1].site) ? (
              "-"
            ) : (
              <Button
                className="custom-color-button"
                startIcon={<HttpsIcon />}
                disabled={
                  customerConfiguredApps[cellValues.id - 1].sslCertsPresent
                }
                size="small"
                variant="contained"
                color="info"
                sx={{
                  mt: 3,
                  mb: 2,
                  backgroundColor: "rgb(0, 104, 74)",
                  fontFamily: "Poppins",
                }}
                onClick={() => generateSsl(cellValues)}
              >
                {customerConfiguredApps[cellValues.id - 1].sslCertsPresent
                  ? "Domain pointed"
                  : "check domain status"}
              </Button>
            )}
          </div>
        );
      },
    },
    {
      field: "serverUrl",
      headerName: "Site URL",
      width: 200,
      cellClassName: "name-column--cell",
      align: "center",
      headerAlign: "center",
    },
    {
      field: "edit",
      headerName: "Edit",
      width: 120,
      align: "center",
      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <Button
            className="custom-color-button"
            endIcon={<EditIcon />}
            type="submit"
            size="small"
            variant="contained"
            color="info"
            sx={{
              mt: 3,
              mb: 2,
              backgroundColor: "rgb(0, 104, 74)",
              fontFamily: "Poppins",
            }}
            onClick={() => handleEdit(cellValues)}
          >
            Edit
          </Button>
        );
      },
    },
    {
      field: "delete",
      headerName: "Delete",
      width: 120,
      align: "center",
      headerAlign: "center",

      renderCell: (cellValues) => {
        return (
          <Button
            endIcon={<DeleteIcon />}
            type="submit"
            size="small"
            variant="contained"
            color="error"
            sx={{ mt: 3, mb: 2, fontFamily: "Poppins" }}
            onClick={() => handleProxyDelete(cellValues)}
          >
            Delete
          </Button>
        );
      },
    },
  ];

  return (
    <Box m="20px">
      {loadingScreen && (
        <div
          style={{
            opacity: "1 !important",
            zIndex: "2",
            textAlign: "center",
            position: "absolute",
            marginLeft: "39%",
            marginTop: "20%",
          }}
        >
          <CircularProgress />
        </div>
      )}
      <div style={{ opacity: loadingScreen ? "0.2" : "1" }}>
        <Header
          title="Configured Apps"
          subtitle="Select App which you want to Edit or Delete"
        />
        <Box
          m="40px 0 0 0"
          height="75vh"
          sx={{
            "& .MuiDataGrid-root": {
              border: "none",
              fontSize: 15,
            },
            "& .MuiDataGrid-cell": {
              borderBottom: "none",
              fontSize: 13.5,
            },

            "& .MuiDataGrid-columnHeaders": {
              backgroundColor: "rgb(0, 104, 74)",
              borderBottom: "none",
            },
            "& .MuiDataGrid-virtualScroller": {
              backgroundColor: "white",
            },
            "& .MuiDataGrid-footerContainer": {
              borderTop: "none",
            },

            "& .MuiDataGrid-toolbarContainer": {
              marginBottom: "10px",
            },
            "& .MuiDataGrid-cell:focus-within": {
              outline: `none !important`,
            },

            "& .MuiDataGrid-cellContent": {
              color: "rgb(0, 30, 43)",
              fontFamily: "Poppins",
            },
            "& .MuiDataGrid-row:hover": {
              backgroundColor: "white !important",
              boxShadow:
                "0px 2px 4px -1px rgba(0,0,0,0.2), 0px 4px 5px 0px rgba(0,0,0,0.14), 0px 1px 10px 0px rgba(0,0,0,0.12)",
            },

            "& .MuiDataGrid-columnSeparator": {
              display: "none !important",
            },
            "& .MuiDataGrid-main": {
              boxShadow:
                "0px 2px 4px -1px rgba(0,0,0,0.2), 0px 4px 5px 0px rgba(0,0,0,0.14), 0px 1px 10px 0px rgba(0,0,0,0.12)",
            },
            "& .MuiDataGrid-menuIcon": {
              color: "white",
            },
          }}
        >
          <DataGrid
            rows={customerConfiguredApps}
            columns={columns}
            getRowId={(row) => row.id}
            components={{ Toolbar: GridToolbar }}
            pageSize={20}
            rowsPerPageOptions={[20]}
            md={12}
            sm={12}
            xs={12}
          />
        </Box>
      </div>
    </Box>
  );
};

export default Contacts;
